import React from 'react';
import { Section } from './ui/Section';
import { Countdown } from './ui/Countdown';
import { Button } from './ui/Button';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
export const FinalUrgency: React.FC = () => {
  return <Section data-id="element-68">
      <div className="max-w-5xl mx-auto" data-id="element-69">
        <div className="text-center mb-12" data-id="element-70">
          <h2 className="text-3xl md:text-5xl font-black mb-8" data-id="element-71">
            ⏰ EL PRECIO CIERRA EN:
          </h2>
          <Countdown data-id="element-72" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-73">
          {/* Plan A */}
          <div className="bg-brand-card border border-brand-card-border rounded-3xl p-8 text-center flex flex-col" data-id="element-74">
            <h3 className="text-xl font-black text-white mb-2" data-id="element-75">
              📘 MEGAPACK NIVEL INICIAL
            </h3>
            <p className="text-brand-green font-bold text-sm mb-6" data-id="element-76">
              6 Tomos + 6 Bonos · Todas las salas
            </p>

            <div className="mb-8 flex-grow" data-id="element-77">
              <span className="text-gray-500 line-through text-lg font-bold block mb-1" data-id="element-78">
                $45.000
              </span>
              <div className="flex items-baseline justify-center gap-2" data-id="element-79">
                <span className="text-4xl font-black text-white" data-id="element-80">$19.990</span>
                <span className="text-lg font-bold text-gray-400" data-id="element-81">ARS</span>
              </div>
            </div>

            <Button href="https://www.tera-ventasonline.shop/cart/45074512609395:1" variant="secondary" fullWidth data-id="element-82">
              → QUIERO MI MEGAPACK
            </Button>
          </div>

          {/* Plan B */}
          <div className="bg-gradient-to-b from-brand-card to-brand-dark border-2 border-brand-green rounded-3xl p-8 text-center flex relative shadow-[0_0_30px_rgba(34,197,94,0.1)] pt-[32px] pb-[32px] flex-col items-start justify-start" data-id="element-83">
            <h3 className="text-xl font-black text-white mb-2" data-id="element-84">
              🏆 MEGAPACK + MÁSTER PROFESIONAL ⭐
            </h3>
            <p className="text-brand-green font-bold text-sm mb-6" data-id="element-85">
              6 Tomos + 6 Bonos + Máster de Personalización Docente
            </p>

            <div className="mb-8 flex-grow" data-id="element-86">
              <span className="text-gray-500 line-through text-lg font-bold block mb-1" data-id="element-87">
                $65.000
              </span>
              <div className="flex items-baseline justify-center gap-2" data-id="element-88">
                <span className="text-4xl font-black text-brand-green" data-id="element-89">
                  $27.990
                </span>
                <span className="text-lg font-bold text-gray-400" data-id="element-90">ARS</span>
              </div>
            </div>

            <Button href="https://www.tera-ventasonline.shop/cart/45074512740467:1" variant="primary" fullWidth data-id="element-91">
              → QUIERO EL MEGAPACK + MÁSTER
            </Button>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-gray-400 font-medium" data-id="element-92">
          <span className="flex items-center gap-2" data-id="element-93">
            <Lock size={16} className="text-brand-green" data-id="element-94" /> Pago 100% seguro
          </span>
          <span className="hidden md:inline" data-id="element-95">·</span>
          <span className="flex items-center gap-2" data-id="element-96">
            <Zap size={16} className="text-brand-green" data-id="element-97" /> Acceso en 5 minutos
          </span>
          <span className="hidden md:inline" data-id="element-98">·</span>
          <span className="flex items-center gap-2" data-id="element-99">
            <Shield size={16} className="text-brand-green" data-id="element-100" /> Garantía 7 días
          </span>
          <span className="hidden md:inline" data-id="element-101">·</span>
          <span className="flex items-center gap-2" data-id="element-102">
            <CreditCard size={16} className="text-brand-green" data-id="element-103" /> Mercado Pago |
            Tarjeta | Transferencia
          </span>
        </div>
      </div>
    </Section>;
};